import {useTranslation} from '@aboutyou/i18n';
import {
  Button,
  COLORS,
  FONT_SIZES,
  FONT_WEIGHTS,
  GenericIconName,
  Icon,
  desktopAndUpLinaria,
  tabletAndDownLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {FC} from 'react';

export const RequestFailure: FC<{
  className?: string;
}> = ({className}) => {
  const {t} = useTranslation();

  return (
    <ErrorWrapper data-testid="walletError" className={className}>
      <IconWrapper>
        <StyledIcon asset={GenericIconName.ErrorTriangle} />
      </IconWrapper>
      <TextWrapper>
        <Title>{t('Oops! Something went wrong.')}</Title>
        <SubTitle>
          {t('We couldn’t load this page. Please try again.')}
        </SubTitle>
        <StyledButton
          htmlType="reset"
          onClick={() => window.location.reload()}
          aria-label={undefined}
        >
          <Icon asset={GenericIconName.Reset} size="S" fill={COLORS.White} />
          {t('Reload site')}
        </StyledButton>
        <Note>{t('Reload in 20 seconds ...')}</Note>
      </TextWrapper>
    </ErrorWrapper>
  );
};

const ErrorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-top: 4rem;

  ${desktopAndUpLinaria(`
    flex-direction: column;
    margin: 0;
    padding: 87px 16px 0;
    text-align: center;
    gap: 25px;
  `)}
`;

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  ${tabletAndDownLinaria(`
    align-items: center;
  `)}

  ${desktopAndUpLinaria(`
    width: 400px;
    align-items: center;
    width: 100%;
  `)}
`;

const Title = styled.h3`
  font-size: ${FONT_SIZES.px20};
  font-weight: ${FONT_WEIGHTS.bold};
  margin: 0;

  ${desktopAndUpLinaria(`
    font-weight: ${FONT_WEIGHTS.mediumHeavy};
    line-height: 1.2;
  `)}
`;

const SubTitle = styled.div`
  font-size: ${FONT_SIZES.px18};

  ${tabletAndDownLinaria(`
    text-align: center;
    padding: 0 40px;
    font-size: ${FONT_SIZES.px18};
    font-weight: ${FONT_WEIGHTS.mediumBold};
    line-height: 1.4;
  `)}
`;

const Note = styled.div`
  font-size: ${FONT_SIZES.px12};
  color: ${COLORS.Grey1};

  ${desktopAndUpLinaria(`
    line-height: 1.5;
    font-weight: ${FONT_WEIGHTS.mediumBold};
  `)}
`;

const StyledIcon = styled(Icon)`
  height: 110px;
  width: 92px;

  ${desktopAndUpLinaria(`
    width: 109px;
    height: 91px;
  `)}
`;

const StyledButton = styled(Button)`
  ${desktopAndUpLinaria(`
    line-height: 1.4;
  `)}
`;
